var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcSupllierDetails = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  viewBox: "0 0 34 34",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_supllier_details",
  transform: "translate(20751 -1241.933)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_320",
  "data-name": "Rectangle 320",
  width: 34,
  height: 34,
  transform: "translate(-20751 1241.933)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_351",
  "data-name": "Rectangle 351",
  transform: "translate(-20749 1248.933)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 30,
  height: 20,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 29,
  height: 19,
  rx: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_348",
  "data-name": "Rectangle 348",
  transform: "translate(-20734 1262.933)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 1,
  rx: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 3,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_349",
  "data-name": "Rectangle 349",
  transform: "translate(-20726 1256.933)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 1,
  rx: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 3,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_355",
  "data-name": "Rectangle 355",
  transform: "translate(-20726 1253.933)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 1,
  rx: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 3,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_352",
  "data-name": "Rectangle 352",
  transform: "translate(-20726 1259.933)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 4,
  height: 1,
  rx: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 3,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_350",
  "data-name": "Rectangle 350",
  transform: "translate(-20734 1256.933)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 1,
  rx: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_354",
  "data-name": "Rectangle 354",
  transform: "translate(-20734 1253.933)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 1,
  rx: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_353",
  "data-name": "Rectangle 353",
  transform: "translate(-20734 1259.933)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 1,
  rx: 0.5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_983",
  "data-name": "Group 983",
  transform: "translate(-21120.84 1131.318)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Path_291",
  "data-name": "Path 291",
  transform: "translate(-2328.887 -1702.568)",
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2703.726,1836.054h10s0-2.483,0-2.824c0-.322-.774-2.291-4.272-2.538a8.609,8.609,0,0,0-1.763,0c-2.914.236-3.965,2.289-3.965,2.642C2703.727,1833.712,2703.726,1836.054,2703.726,1836.054Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 2712.7255859375 1835.054077148438 C 2712.72509765625 1834.4091796875 2712.724853515625 1833.635498046875 2712.725830078125 1833.321655273438 C 2712.634765625 1833.098510742188 2712.0146484375 1831.875244140625 2709.38330078125 1831.689208984375 L 2709.24462890625 1831.679321289062 C 2708.929443359375 1831.656860351562 2708.78564453125 1831.646606445312 2708.655517578125 1831.646606445312 C 2708.5400390625 1831.646606445312 2708.397705078125 1831.654541015625 2708.138916015625 1831.668823242188 C 2708.03271484375 1831.674682617188 2707.908203125 1831.681640625 2707.758056640625 1831.689453125 C 2705.7587890625 1831.856689453125 2704.889404296875 1833.058471679688 2704.7265625 1833.444946289062 C 2704.726806640625 1833.758056640625 2704.726806640625 1834.45751953125 2704.7265625 1835.054077148438 L 2712.7255859375 1835.054077148438 M 2713.726318359375 1836.054077148438 L 2703.726318359375 1836.054077148438 C 2703.726318359375 1836.054077148438 2703.727294921875 1833.711791992188 2703.726318359375 1833.334106445312 C 2703.725830078125 1832.980590820312 2704.77734375 1830.927856445312 2707.69091796875 1830.691650390625 C 2708.764892578125 1830.635375976562 2708.55224609375 1830.627807617188 2709.453857421875 1830.691650390625 C 2712.9521484375 1830.93896484375 2713.7294921875 1832.908203125 2713.726318359375 1833.229858398438 C 2713.7236328125 1833.571411132812 2713.726318359375 1836.054077148438 2713.726318359375 1836.054077148438 Z",
  stroke: "none",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_59",
  "data-name": "Ellipse 59",
  transform: "translate(376.839 121.743)",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 3,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 3,
  cy: 3,
  r: 2.5,
  fill: "none"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcSupllierDetails);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_supllier_details.30e92043ac75c1d73d4c98c118995f3d.svg";